import React from 'react';
import Image from 'next/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles/elements/Loding.module.scss';

const LoadingFullPage = (props) => {

    const {message, showLogo} = props;

    return(
        <Row className={` h-100 ${styles.fullPage}`}>
            <Col className={`mb-5 d-flex align-items-center justify-content-center flex-column ${styles.full_screen_msg}`}>
                {showLogo &&  
                <div className="mx-auto mb-5">
                    <Image src="/images/icons/conso.png" width={111} height={33} classes="" alt="Conso" /> 
                </div>
                }
                <Spinner animation="border" variant="success" size="lg" className="me-2" /> 
                <p>{message}</p>
            </Col>
        </Row>
    );
}

export default LoadingFullPage;